import { useAppContext } from '../contexts/App.context'
import { stringToSnakeCell } from '../functions/onchainMeta'
import { makeChoicesDictionary } from './useCreateBox.functions'
import type { CreateBox } from './useCreateBox.types'
import { isE2ETestMode, getMockBlockchainResult } from '../utils/testMode'

export function useCreateBox() {
  const { sender, boxCollection } = useAppContext()

  return {
    sendCreateBoxMessage: async (box: CreateBox, value: bigint) => {
      // In E2E test mode, return mock result instead of real blockchain call
      if (isE2ETestMode()) {
        const mockResult = getMockBlockchainResult()
        if (mockResult) {
          // Simulate network delay
          await new Promise(resolve => setTimeout(resolve, 500))
          if (!mockResult.isSuccess) {
            throw new Error('Transaction rejected (E2E mock)')
          }
          return // Success - just return without throwing
        }
      }

      const {
        name,
        imageUrl,
        choices,
        endTimeInSeconds,
        creatorBasisPoints,
        publishToFeed,
      } = box

      if (!boxCollection) {
        throw new Error('Box collection contract is not initialized.')
      }

      if (!sender) {
        throw new Error('Sender is not initialized.')
      }

      console.log('Отправка сообщения для создания голосования...')

      const result = await boxCollection.send(
        sender,
        { value },

        {
          $$type: 'CreateBoxV0',
          name: stringToSnakeCell(name),
          description: stringToSnakeCell('Box item'),
          image: stringToSnakeCell(imageUrl || DEFAULT_IMAGE),
          choices: makeChoicesDictionary(choices),
          end_time: endTimeInSeconds,
          creator_basis_points: creatorBasisPoints,
          feed_display: publishToFeed,
        },
      )

      console.log('Сообщение успешно отправлено!', result)
    },
  }
}

const DEFAULT_IMAGE = 'https://static.testnet.votebox.io/boxes/default.png'
